<template>
  <div>
    <div v-html="text"></div>
  </div>
</template>

<script>
// import { infoHtml } from '@/pages/IndicadoresAps/IndicadorCitologico/utils.js'
export default {
  data() {
    return {
      text: '',
    }
  },
}
</script>

<style scoped lang="scss" src="@/pages/Documentacao/Views/stylesManual.scss" />
